export var EonAccountType;
(function (EonAccountType) {
    EonAccountType["TYPE_UNSPECIFIED"] = "UNSPECIFIED";
    EonAccountType["EXTERNAL_PAYING"] = "EXTERNAL_PAYING";
    EonAccountType["EXTERNAL_NON_PAYING"] = "EXTERNAL_NON_PAYING";
    EonAccountType["INTERNAL"] = "INTERNAL";
    EonAccountType["EXTERNAL_FREE_PROTECTION"] = "EXTERNAL_FREE_PROTECTION";
})(EonAccountType || (EonAccountType = {}));
